import * as React from "react";
import { container, mobileCtaBanner } from "./MobileCta.module.scss";
import BackgroundImage from "gatsby-background-image";
import { convertToBgImage } from "gbimage-bridge";
import { getImage } from "gatsby-plugin-image";

export const Container: React.FC<any> = (props) => {
  return <div className={container}>{props.children}</div>;
};

export const MobileCtaBanner: React.FC<any> = (props) => {
  const ctaData = props.node ? props.node : null;
  const image = ctaData?.relationships.field_media
    ? getImage(
        ctaData.relationships.field_media.relationships.field_media_image
          .gatsbyImage as any
      )
    : null;
  const _bgImage = convertToBgImage(image);
  return (
    <BackgroundImage
      {..._bgImage}
      preserveStackingContext
      className={mobileCtaBanner}
    >
      {props.children}
    </BackgroundImage>
  );
};

export const Title: React.FC<any> = (props) => {
  return <h2 className="title">{props.children}</h2>;
};
